import React from 'react'
import * as ReactDOM from 'react-dom'
import { Button, Typography, withStyles, withWidth } from '@material-ui/core'
import pic_cut_1 from '../../media/picture_cuts/pic_1.jpg'
import pic_cut_2 from '../../media/picture_cuts/pic_2.jpg'
import pic_cut_3 from '../../media/picture_cuts/pic_3.jpg'
import pic_cut_4 from '../../media/picture_cuts/pic_4.jpg'
import pic_cut_5 from '../../media/picture_cuts/pic_5.jpg'
import pic_cut_6 from '../../media/picture_cuts/pic_6.jpg'
import pic_cut_7 from '../../media/picture_cuts/pic_7.jpg'
import pic_cut_8 from '../../media/picture_cuts/pic_8.jpg'
import pic_cut_9 from '../../media/picture_cuts/pic_9.jpg'
import originalPicture from '../../media/picture_cuts/Original_picture.jpg'
import { scrollToTop } from './ArticlePointMapSegment'

export const POINTS_TO_QUESTIONS = 'POINTS_TO_QUESTIONS'

const styles = theme => ({
  caption: {
    margin: 20,
    fontSize: theme.typography.fontSize
  },
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 26,
    borderColor: 'brown',
    width: 300,
    height: 450,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  symbolCardImage: {
    width: '100%',
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
  startButton: {
    fontSize: theme.typography.h1.fontSize,
  },
  originalPicture: {
    marginBottom: 20,
    width: '100%'
  },
  pictureQuestionContainer: {
    textAlign: 'center',
  },
  pictureImg: {},
  activityContainer: {
    minHeight: 700,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    /* align-content: center, */
    alignItems: 'center',
  },
  wouldYou: {
    margin: '20px 0'
  }
})

const image_map = [
  { //1
    x1: 170, y1: 500, x2: 470, y2: 718,
    question: 'A poet will read from his book',
    pic: pic_cut_1
  },
  {//2
    x1: 0, y1: 0, x2: 170, y2: 500,
    pic: pic_cut_2,
    question: 'A school group is on a nature walk, learning about trees in the park?'
  },
  {//3
    x1: 880, y1: 0, x2: 1074, y2: 718,
    pic: pic_cut_3,
    question: 'The teacher stands in front of the tree explaining the students the species in the forest?'
  },
  {//4
    x1: 470, y1: 620, x2: 880, y2: 718,
    pic: pic_cut_4,
    question: 'It is summer?'
  },
  {//5
    x1: 470, y1: 0, x2: 880, y2: 280,
    pic: pic_cut_5,
    question: 'This is a controversial event?'
  },
  {//6
    x1: 170, y1: 350, x2: 470, y2: 500,
    pic: pic_cut_6,
    question: 'This is a group of women?'
  },
  {//7
    x1: 170, y1: 0, x2: 470, y2: 350,
    pic: pic_cut_7,
    question: 'This place is a venue of mass atrocity?'
  },
  {//8
    x1: 470, y1: 350, x2: 880, y2: 620,
    pic: pic_cut_8,
    question: 'People are having a lot of fun?'
  },

  {//9
    x1: 470, y1: 280, x2: 880, y2: 350,
    pic: pic_cut_9,
    question: 'The group commemorates Holocaust Memorial Day on 2 May?'
  },
]

class PictureCutSegment extends React.Component {
  state = {
    map: null,
    correct: false,
    currentArea: null,
    currentPicture: 0,
    started: false,
  }

  componentDidMount () {
    this.setState({ map: image_map })

    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()

    setTimeout(() => scrollToTop(this), 500)
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.boundingRect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
  }

  handleClick = (area, index, event) => {
    let newMap = this.state.map

    newMap.areas[area.name].preFillColor = 'rgba(0,0,0,0)'
    newMap.areas[area.name].anwsered = true
    let correct = this.checkCorrect(newMap)
    this.setState({ map: newMap, correct, currentArea: area })
  }

  checkCorrect (newMap) {
    for (let area of newMap.areas) {
      if (!area.anwsered) {
        return false
      }
    }
    return true
  }

  handleNo () {
    this.advance()
  }

  handleYes () {
    this.advance()
  }

  advance () {
    let currentPicture = this.state.currentPicture
    currentPicture++
    if (currentPicture >= this.state.map.length) {
      this.setState({ correct: true })
    } else {
      this.setState({ currentPicture: currentPicture })
    }
  }

  render () {
    let {
      className, classes
      // ...props
    } = this.props
    let { correct, map, started, currentPicture } = this.state

    return <div className={className}>
      <Typography variant={'h1'}>
        Heroes
      </Typography>
      {!correct && <div className={classes.activityContainer}>
        {!started && !correct && <Button onClick={() => {this.setState({ started: true })}}
                                         color="primary" className={classes.startButton}>
          Start Questions
        </Button>
        }
        {started && !correct && <div className={classes.pictureQuestionContainer}>
          <img alt="picture_for_question" src={map[currentPicture].pic}/>
          <Typography>
            {map[currentPicture].question}
          </Typography>
          <div>
            <Button onClick={() => {
              this.handleNo()
            }} color="primary" className={classes.startButton}>
              No
            </Button>
            <Button onClick={() => {
              this.handleYes()
            }} color="primary" className={classes.startButton}>
              Yes
            </Button>
          </div>
        </div>}
      </div>
      }
      <div className={classes.caption}>
        {correct && <div>
          <img alt="original_picture" src={originalPicture} className={classes.originalPicture}/>
          <Typography variant='h1'>
            Photo: Tomas Jakūbonis
          </Typography>
          <Typography>
            In November 2018 group of teachers and educators visited the venue in the woods near Paneriai village where
            mass
            extermination of Jews, Poles, Lithuanians, and members of other communities happened. The group stands in
            front
            of the monument, that was erected in 1991 to commemorate the Jews killed in Paneriai.
          </Typography>

        </div>}
        {correct && <div className={classes.wouldYou}>
          <Typography variant='h1'>
            Would you like to do this activity offline?
          </Typography>
          <ol>
            <li>Print the <a
              href="https://drive.google.com/drive/folders/11hbfLvlN0hOWeMg4pPzqYGcQ6-VQT9de?ths=true">picture</a> and
              cut it in small pieces as indicated. You can also use your own picture.
            </li>
            <li> Organize participants into small groups of 4-5 members. Distribute pieces of the picture to the group.
              Have
            </li>
            <li> the groups draw what they think is missing from the rest of the photo, without looking at other
              pieces.
            </li>
            <li> Have the group share their illustrations with one another and engage in discussion about their visual
              stories.
            </li>
            <li> Collect all of the pieces and assemble them to reveal the entire picture.</li>
            <li> Follow the activity with the reflection questions.</li>
          </ol>
        </div>}
      </div>
    </div>
  }
}

export default withWidth()(withStyles(styles, { withTheme: true })(
  PictureCutSegment
))
